import React, { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';

export interface SideBarItemProps {
  iconLeft: React.ReactNode;
  iconRight?: React.ReactNode;
  text: string;
  selected: boolean;
  collapsed: boolean;
  onClick?: (event: any) => void;
  className?: string;
  textClassName?: string;
  /** Short tag shown right after the text (design system "Label - Status", green). */
  badge?: string;
  /** Shows a hover-only "+" button that creates a new task in this module. */
  onCreateClick?: (event: React.MouseEvent) => void;
}

export const SideBarItem: React.FC<SideBarItemProps> = ({
  iconLeft,
  iconRight,
  text,
  selected,
  collapsed,
  onClick,
  className,
  onCreateClick,
  badge,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`h-8 flex items-center justify-center gap-2 cursor-pointer rounded bg-brand-white border border-solid ${selected ? 'bg-taskonioGreen-100 border-taskonioGreen-200' : 'border-transparent hover:bg-neutral-200'} ${collapsed ? '' : 'px-1.5'} ${className ? className : ''}`}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className={`w-4 h-4 flex items-center justify-center ${selected ? 'text-brand-grey-dark' : 'text-neutral-900'}`}
      >
        {iconLeft}
      </div>
      {!collapsed && (
        <div
          className={`text-sm flex-1 overflow-hidden text-ellipsis whitespace-nowrap ${selected ? 'text-brand-grey-dark font-medium' : 'text-neutral-900 font-normal'}`}
        >
          {text}
          {badge && (
            <span className="ml-1.5 rounded-sm bg-green-100 px-1 align-middle text-[10px] font-medium leading-3 text-green-600">
              {badge}
            </span>
          )}
        </div>
      )}
      {!collapsed && onCreateClick && isHovered && (
        <div
          className="w-5 h-5 flex items-center justify-center rounded text-neutral-900 hover:bg-neutral-300"
          onClick={(e) => {
            e.stopPropagation();
            onCreateClick(e);
          }}
        >
          <PlusOutlined />
        </div>
      )}
      {!collapsed && iconRight}
    </div>
  );
};

export default SideBarItem;
